module.exports = __webpack_public_path__ + "static/media/logo_light.170b4c03.svg";